/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { createStore, infigo, MiddleWare } from '@dm/live-material-infigo';

import { DefaultDetailComponent } from './components/default-detail/default-detail.component';
import { FileSystemsDetailComponent } from './components/file-systems-detail/file-systems-detail.component';
import { HostDetailComponent } from './components/host-detail/host-detail.component';
import { HostGroupDetailComponent } from './components/host-group-detail/host-group-detail.component';
import { LogicPortDetailComponent } from './components/logic-port-detail/logic-port-detail.component';
import { LunDetailComponent } from './components/lun-detail/lun-detail.component';
import { LunGroupDetailComponent } from './components/lun-group-detail/lun-group-detail.component';
import { LunSnapShotDetailComponent } from './components/lun-snap-shot-detail/lun-snap-shot-detail.component';
import { PortGroupDetailComponent } from './components/port-group-detail/port-group-detail.component';
import { RecycleBinComponent } from './components/recycle-bin/recycle-bin.component';
import { TenantDetailComponent } from './components/tenant-detail/tenant-detail.component';
import { InitStatusComponent } from './init-status/init-status.component';
import { InputComponent } from './input/input.component';
import { MonopolizeSearchComponent } from './monopolize-search/monopolize-search.component';
import { SearchStatusComponent } from './search-status/search-status.component';
// 初始化Store
const { StatusMiddleWare, SearchMiddleWare } = MiddleWare;
const store = createStore(StatusMiddleWare, SearchMiddleWare);
if (!store) {
    throw new Error('no store exist');
}
infigo.statusDOMTree = {
    INIT: [
        [InputComponent],  // TOP
        [InitStatusComponent],
    ],
    SEARCH: [
        [InputComponent],
        [SearchStatusComponent],
    ],
    MONOPOLIZE_SEARCH: [
        [InputComponent],
        [MonopolizeSearchComponent],
    ],
};
infigo.registerRender([
    'lun', LunDetailComponent,
    'lunGroup', LunGroupDetailComponent,
    'Namespace', LunDetailComponent,
    'NamespaceGroup', LunGroupDetailComponent,
    'portGroup', PortGroupDetailComponent,
    'host', HostDetailComponent,
    'hostGroup', HostGroupDetailComponent,
    'tenant', TenantDetailComponent,
    'logicPort', LogicPortDetailComponent,
    'lunSnapShot', LunSnapShotDetailComponent,
    'fileSystems', FileSystemsDetailComponent,
    'clone', LunDetailComponent,
    'peLun', LunDetailComponent,
    'vvolLun', LunDetailComponent,
    'recycleBin', RecycleBinComponent,
    'default', DefaultDetailComponent,
]);

export const initSuccess = true;
